module.exports = __webpack_public_path__ + "assets/img/dzh-33.4f1ef9b9.gif";